import config from 'Config'
import get from 'lodash/get'

export const resolveContentCardSkins = pageName => {
  const contentListSkins = get(config, `contentListSkins.${pageName}`, '')
  return contentListSkins
}
